import { getGridPos, lerp } from './utils'
import Tile from './Tile'
import Bar from './Bar'

class Enemy extends Tile {
  constructor(type, path, successEnemy, killEnemy) {
    const pos = getGridPos(path[0].gridSpot)
    super(pos)
    this.type = 'ENEMY'

    this.gridSpot = path[0].gridSpot
    this.defaultMoveTimer = 50
    this.moveTimer = this.defaultMoveTimer
    this.path = path
    this.step = 0
    this.successEnemy = successEnemy
    this.killEnemy = killEnemy
    this.hp = 100

    this.healthBar = new Bar(this, '#ff0000', { x: 10, y: 40 })

    const image = document.getElementById('enemy')
    this.img = image
    this.animationStep = 0
    this.time = 0
  }

  draw(c) {
    if(this.img) {
      c.drawImage(this.img, 64*this.animationStep, 0, 64, 64, this.x, this.y, 64, 64)

      if(this.time%4 === 0) {
        this.animationStep++
        if(this.animationStep > 6) {
          this.animationStep = 0
        }
      }
    }
  }

  update(c) {
    this.time++
    if(this.hp <= 0) {
      // TODO add coin animation
      this.killEnemy(this)
    }

    this.draw(c)
    this.healthBar.update(c, this.hp/100)
    this.moveTimer--

    const startPos = getGridPos(this.path[this.step].gridSpot)
    const nextPos = this.path[this.step+1] ? getGridPos(this.path[this.step+1].gridSpot) : {}

    this.x = lerp(startPos.x, nextPos.x, this.moveTimer / this.defaultMoveTimer)
    this.y = lerp(startPos.y, nextPos.y, this.moveTimer / this.defaultMoveTimer)

    if(this.moveTimer < 0) {
      this.moveTimer = this.defaultMoveTimer
      this.step++

      if(!this.path[this.step]) {
        this.successEnemy(this)
      } else {
        this.gridSpot = this.path[this.step].gridSpot
      }
    }
  }
}
export default Enemy
